module.exports = __webpack_public_path__ + "static/media/home_page_archero2_background@2x.0a586179.png";